import classNames from 'classnames'
import { TFunction } from 'i18next'
import 'lazysizes'
import * as React from 'react'
import { withTranslation } from 'react-i18next'
import { useAppState } from '../../appState'
import ShopNowLink from '../shopNowLink'
import { styles } from './styles'
interface BrandItemProps {
  name: string
  brandLogo: any
  cashBack?: string
  isCashbackShownInWebsite?: boolean
  isActive?: boolean
  customStyle: any
  t: TFunction
  link: string
  originalUrl?: string
  isCardOnLanding?: boolean
}

const NewBrandItem = ({
  name,
  brandLogo,
  link,
  originalUrl,
  cashBack,
  isCashbackShownInWebsite = true,
  isActive,
  customStyle,
  isCardOnLanding,
  t,
  ...props
}: BrandItemProps) => {
  const classes = styles()
  const [appState] = useAppState()
  const cashBackClasses = classNames({
    [classes.cashBackText]: true,
    [classes.cashBackTextActive]: isActive,
    [customStyle]: customStyle,
  })
  const cardBackground = isCardOnLanding
    ? appState.username
      ? classes.whiteCard
      : classes.whiteCardOld
    : ''

  return (
    <div className={`${classes.card} ${cardBackground}`}>
      <ShopNowLink href={link} originalUrl={originalUrl} rel="noreferrer">
        <img
          src={brandLogo}
          alt={name}
          className={classes.logo + ' lazyload '}
        />
        {cashBack && isCashbackShownInWebsite ? (
          <p className={cashBackClasses}>
            {t('home.earnPercentBack', { percent: cashBack })}
          </p>
        ) : (
          <p className={cashBackClasses}>{t('home.shopNow')}</p>
        )}
      </ShopNowLink>
    </div>
  )
}

export default withTranslation()(NewBrandItem)
